/* eslint-disable no-bitwise */
export const isFileAllowed = (file) => {
    const allowedExtensions = [".heic", ".png", ".jpg", ".jpeg"];
    const fileName = file.name;
    const fileExtension = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
    
    return allowedExtensions.includes(`.${fileExtension.toLowerCase()}`);
  };
  